import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Job } from '@ats/models';
import { socialMedia, SocialMedia } from '@commons/share-popup/social-media';
import { buildUrl } from '@wizbii/angular-utilities';

interface ShareLink {
  media: SocialMedia;
  url: SafeUrl;
}

@Component({
  selector: 'app-job-share-popup',
  templateUrl: './share-popup.component.html',
  styleUrls: ['./share-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharePopupComponent {
  @Output() openShare = new EventEmitter<void>();
  @Output() share = new EventEmitter<string>();

  shareLinks: ShareLink[] = [];
  private _job: Job;

  constructor(private readonly sanitizer: DomSanitizer) {}

  @Input()
  get job(): Job {
    return this._job;
  }

  set job(job: Job) {
    this._job = job;

    // Construct job's permalink

    // tslint:disable-next-line:no-suspicious-comment
    // TODO change permalink
    const permalink = `https://www.atsii.com/job/${job._id}`;

    // Compute sharing URL for each social media
    this.shareLinks = socialMedia.map(item => {
      // Invoke `getParams` function and build URL
      const params = item.getShareParams(permalink, job);
      const url = buildUrl(item.shareUrl, params);

      // Trust URL so Angular doesn't prepend `unsafe:` when protocol is unknown
      const safeUrl = this.sanitizer.bypassSecurityTrustUrl(url);

      return {
        media: item,
        url: safeUrl,
      };
    });
  }

  trackByLabel(_, media: SocialMedia) {
    return media.label;
  }
}
